import { Box, BoxProps } from '@mui/material'
import { motion } from 'motion/react'
import React from 'react'
import { EnterPreset, ExitPreset, PresetEasing, useMotionPreset } from './animationPresets'

interface Props extends Omit<BoxProps, 'component' | 'event' | 'ref' | 'definition' | 'onDrag' | 'onDragStart' | 'onDragEnd' | 'onAnimationStart'> {
  entering?: EnterPreset | EnterPreset[]
  exiting?: ExitPreset | ExitPreset[]
  durationMs?: number
  delayStep?: number
  delayN?: number
  delayMs?: number
  easing?: PresetEasing
  layout?: boolean | 'position'
}

const MotionBox = motion.create(Box)

const AnimatedBox = React.forwardRef((props: Props & Record<string, unknown>, ref) => {
  const {
    layout = false,
    entering,
    exiting,
    durationMs = 400,
    easing = 'easeOutExpo',
    delayMs = 0,
    delayN = 0,
    delayStep = 50,
    ...rest
  } = props

  const motionPreset = useMotionPreset({ entering, exiting, easing, durationMs, delayN, delayMs, delayStep, overrides: rest })

  return <MotionBox
    {...rest}
    {...motionPreset}
    layout={layout}
    ref={ref}
  />
})

AnimatedBox.displayName = 'AnimatedBox'
export default motion.create(AnimatedBox)
